import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, ShoppingBag, User } from 'lucide-react';
import { useApp } from '@/state/AppContext';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ed722c14-f6d3-48d4-b5ee-3466358d0c74/artifacts/mwshbcey_BIG%20BASH%20LOGO.svg';

export const Header = () => {
  const { cartCount, setSearchOpen } = useApp();
  const navigate = useNavigate();
  // Bump animation when cart count increases
  const prevCountRef = useRef(cartCount);
  const [bumpKey, setBumpKey] = useState(0);
  useEffect(() => {
    if (cartCount > prevCountRef.current) setBumpKey((k) => k + 1);
    prevCountRef.current = cartCount;
  }, [cartCount]);

  return (
    <header
      className="md:hidden sticky top-0 z-40 bg-white border-b-2 border-[var(--bb-darkblue)]/10"
      data-testid="site-header"
    >
      <div className="max-w-6xl mx-auto px-4 h-14 flex items-center gap-2">
        <Link to="/" className="flex items-center shrink-0" data-testid="header-logo">
          <img src={LOGO_URL} alt="Big Bash" className="h-8 w-auto" />
        </Link>
        <button
          type="button"
          onClick={() => setSearchOpen(true)}
          className="flex-1 h-10 px-3 rounded-xl border border-[var(--bb-darkblue)]/15 bg-[var(--bb-cyan-soft)] text-left text-sm text-[var(--bb-darkblue)]/70 font-nunito-bold flex items-center gap-2 active:scale-[0.98] transition-transform duration-150 hover:bg-[var(--bb-cyan-soft)]/80"
          data-testid="header-search-trigger"
          aria-label="Open search"
        >
          <Search className="w-4 h-4" />
          <span className="truncate">Search…</span>
        </button>
        <button
          type="button"
          onClick={() => navigate('/profile')}
          className="h-10 w-10 rounded-xl flex items-center justify-center hover:bg-[var(--bb-yellow-soft)] active:scale-90 transition-all duration-150"
          aria-label="Profile / Track order"
          data-testid="header-profile-button"
        >
          <User className="w-5 h-5" />
        </button>
        <button
          type="button"
          onClick={() => navigate('/cart')}
          className="relative h-10 w-10 rounded-xl flex items-center justify-center hover:bg-[var(--bb-yellow-soft)] active:scale-90 transition-all duration-150"
          aria-label="Cart"
          data-testid="header-cart-button"
        >
          <ShoppingBag
            key={`cart-${bumpKey}`}
            className={`w-5 h-5 ${bumpKey > 0 ? 'bb-anim-cart-bump' : ''}`}
          />
          {cartCount > 0 && (
            <span
              key={`badge-${bumpKey}`}
              className="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full bg-[var(--bb-pink)] text-white text-[11px] font-extrabold flex items-center justify-center border-2 border-white bb-anim-bounce-in"
              data-testid="header-cart-count"
            >
              {cartCount}
            </span>
          )}
        </button>
      </div>
    </header>
  );
};
